module.exports = __webpack_public_path__ + "img/1.14c9b427.jpg";